import * as yup from 'yup'

export const authSchema = yup.object().shape({
  emailAddress: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),

  phoneNumber: yup
    .string()
    .test('Phone number length check', (value, context) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (!value!.length) {
        return true
      }

      const regex = new RegExp('^[0-9]+$')
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (!regex.test(value!)) {
        return context.createError({
          message: 'Phone number should be numbers only',
        })
      }

      if (value && value.length !== 10) {
        return context.createError({
          message: 'Phone number should be 10 characters',
        })
      }

      return true
    })
    .required('Phone number is required'),
  acceptTerms: yup
    .boolean()
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .test('should accept terms', 'Please accept terms', (value) => value!),
})

export const authSchemaWithoutTerms = yup.object().shape({
  emailAddress: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),

  phoneNumber: yup
    .string()
    .test('Phone number length check', (value, context) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (!value!.length) {
        return true
      }

      const regex = new RegExp('^[0-9]+$')
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (!regex.test(value!)) {
        return context.createError({
          message: 'Phone number should be numbers only',
        })
      }

      if (value && value.length !== 10) {
        return context.createError({
          message: 'Phone number should be 10 characters',
        })
      }

      return true
    })
    .required('Phone number is required'),
})

export const VERIFICATION_CODE_LENGTH = 6

export const verificationCodeSchema = yup.object().shape({
  verificationCode: yup
    .string()
    .required('Verification code is required')
    .matches(
      new RegExp(`^\\d{${VERIFICATION_CODE_LENGTH}}$`),
      `Please enter all ${VERIFICATION_CODE_LENGTH} digits of your verification code`
    ),
})
